import { PromotionDisplayExternalType, PromotionsTypes } from '../types/response';

export const getExternalPromotions = (promotions: PromotionsTypes[]): PromotionsTypes[] => {
  return (promotions || []).filter(
    (item) => item.displayExternalType === PromotionDisplayExternalType.EXTERNAL_OPTINMONSTER
  );
};
